import { setOnboardingActive_actionType } from "../constants";

export const setOnboardingActive = (isActive) => {
  return {
    type: setOnboardingActive_actionType,
    payload: isActive,
  };
};
